import { render, staticRenderFns } from "./JournalRow.vue?vue&type=template&id=21e8b6e5&scoped=true&"
import script from "./JournalRow.vue?vue&type=script&lang=js&"
export * from "./JournalRow.vue?vue&type=script&lang=js&"
import style0 from "./JournalRow.vue?vue&type=style&index=0&id=21e8b6e5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e8b6e5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
